module.exports = __webpack_public_path__ + "img/icon-deadline.4ef0a06d.png";